import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import routes from './routes/routes';
import NotFoundPage from './pages/notFound';



function App() {
  const renderRoutes = (routes) =>
    routes.map((route, i) => {
      if (route.childRoutes) {
        return route.childRoutes.map((child, j) => (
          <Route
            key={`${i}-${j}`}
            exact={child.exact}
            path={`${route.path}${child.path}`}
            component={child.component}
          />
        ));
      }

      return (
        <Route
          key={i}
          path={route.path}
          exact={route.exact}
          component={route.component}
        />
      );
    });
  return <Switch>
    {/* ✅ Redirect from `/` to `/home` */}
    <Route exact path="/">
      <Redirect to="/home" />
    </Route>

    {/* ✅ Render all defined routes */}
    {renderRoutes(routes)}

    {/* ✅ Catch-all 404 — must stay last in the Switch */}
    <Route component={NotFoundPage} />
  </Switch>;
}

export default App;
